<span *ngIf="rawText" [id]="rawText.id" [ngClass]="rawText.style | floCssClassSanitize">
  {{rawText.text}}
</span>
